import React from "react";
import { FCard } from ".";
import { Box, Typography } from "@mui/material";
import { StatProgressBar } from "../progress-bar/StatProgressBar";
import { highlightText } from "../../utils/highlightText";
import { smartTruncateString } from "../../utils/smartTruncation";
export const ProjectCard = ({ projectName, projectStatus, daysPassed, totalDays, omzet, onClick, omzetTarget, percent, searchTerm, isSearchResult = false, }) => {
    return (React.createElement(FCard, { onClick: onClick },
        React.createElement(Typography, { variant: "h6", fontWeight: 400, sx: { mb: 1 } }, typeof projectName === "string"
            ? smartTruncateString(projectName, 90)
            : projectName),
        projectStatus && projectStatus.trim() !== "" && (React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 0.75 } }, isSearchResult && searchTerm && searchTerm.trim() !== ""
            ? highlightText(`Status: ${projectStatus}`, searchTerm)
            : `Status: ${projectStatus}`)),
        React.createElement(Typography, { variant: "body2", sx: { mb: 0.75 } },
            React.createElement(Box, { component: "span", fontWeight: 700 }, daysPassed),
            " ",
            React.createElement(Box, { component: "span", fontWeight: 500 }, "van de"),
            " ",
            React.createElement(Box, { component: "span", fontWeight: 700 }, totalDays),
            " ",
            "dagen verstreken"),
        React.createElement(Box, null,
            React.createElement(StatProgressBar, { value: "", labelFontWeight: 400, labelFonts: "h4", percent: percent, color: "#4DB6F6", bgColor: "#E3F2FD", height: 20, labelColor: "#3192D0", label: "" })),
        React.createElement(Typography, { sx: { mt: 0.75 }, variant: "body2", color: "text.primary" }, isSearchResult && searchTerm && searchTerm.trim() !== ""
            ? highlightText(`${percent} % Voltooid`, searchTerm)
            : `${percent} % Voltooid`)));
};
